import React, { useState, useMemo } from 'react'
import { dateCol, numCol } from '@integec/grid-tools/lib/cols'
import CommonScreen from '../admin/component/CommonScreen'
import { getApiTargetInfo, UtilityUnitSelection } from 'core'
import { connect } from 'react-redux'
import { DatePicker, Button, InputNumber } from 'antd'
import { Label } from 'core/screen-util'
import { utilityHeader, unitIdHeader } from 'core/HeaderColTypeProps'
import { getUtilityNameMap, getUnitNameMap } from 'core/selectors'
import {
  getPJMUnitTransfer,
  deletePJMUnitTransfer,
  savePJMUnitTransfer,
} from '../api/pgads'

const title = 'Dynamic Unit Transfer'

const PJMUnitTransfer = ({ utilityNameMap, unitNameMap }) => {
  const [insertEvent, setInsertEvent] = useState(false)

  const withCriteria = (state, props, selectedUnits = []) => ({
    unitid: selectedUnits.map(u => u.unitId),
  })

  const headerWithFormatter = useMemo(
    _ =>
      PJMUnitTransferHeaders.map(h =>
        h.ident === 'utility'
          ? {
              ...h,
              // ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) => utilityNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.utility] || rowData.utility,
            }
          : h.ident === 'unitId'
          ? {
              ...h,
              choices: [],
              // dataGetter: generateDataGetter,
              dataFormatter: ({ value }) => unitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unit] || rowData.unit,
            }
          : h.ident === 'upperUtility'
          ? {
              ...h,
              // ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) => utilityNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.upperUtility] || rowData.upperUtility,
            }
          : h.ident === 'upperUnitId'
          ? {
              ...h,
              choices: [],
              // dataGetter: generateDataGetter,
              dataFormatter: ({ value }) => unitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.upperUnit] || rowData.upperUnit,
            }
          : h.ident === 'lowerUtility'
          ? {
              ...h,
              // ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) => utilityNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.lowerUtility] || rowData.lowerUtility,
            }
          : h.ident === 'lowerUnitId'
          ? {
              ...h,
              choices: [],
              // dataGetter: generateDataGetter,
              dataFormatter: ({ value }) => unitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.lowerUnit] || rowData.lowerUnit,
            }
          : h
      ),
    [unitNameMap, utilityNameMap]
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <div
      style={{
        width: '100%',
        borderSpacing: '10px',
        borderCollapse: 'inherit',
        display: 'grid',
        gridTemplateColumns: '150px 700px 150px 200px',
        gap: '5px',
      }}
    >
      <Label>Utility / Unit : </Label>

      <UtilityUnitSelection
        utility={insertData.utility}
        unit={insertData.unitId}
        onUnitChange={value => {
          // setUtilityUnit(value)
          setInsertData({
            ...insertData,
            utility: value[0],
            unitId: value[1],
            unit: value[1].substr(3),
          })
        }}
      />

      <Label>Effective Date : </Label>

      <DatePicker
        allowClear={false}
        format="MM/DD/YYYY"
        value={insertData.effectiveDateMom}
        onChange={date => {
          setInsertData({
            ...insertData,
            effectiveDateMom: date,
            effectiveDate: date.format('YYYY-MM-DD'),
          })
        }}
      />

      <Label>(Upper) Utility / Unit : </Label>

      <UtilityUnitSelection
        utility={insertData.upperUtility}
        unit={insertData.upperUnitId}
        onUnitChange={value => {
          // setUtilityUnit(value)
          setInsertData({
            ...insertData,
            upperUtility: value[0],
            upperUnitId: value[1],
            upperUnit: value[1].substr(3),
          })
        }}
      />

      <Label>Threshold : </Label>

      <InputNumber
        defaultValue={0}
        onChange={value => setInsertData({ ...insertData, threshold: value })}
      />

      <Label>(Lower) Utility / Unit : </Label>

      <UtilityUnitSelection
        utility={insertData.lowerUtility}
        unit={insertData.lowerUnitId}
        onUnitChange={value => {
          // setUtilityUnit(value)
          setInsertData({
            ...insertData,
            lowerUtility: value[0],
            lowerUnitId: value[1],
            lowerUnit: value[1].substr(3),
          })
        }}
      />

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '100px 100px 100px',
          gap: '5px',
        }}
      >
        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>

        <Button type="primary" onClick={() => onAdd(false)}>
          Add & Hide
        </Button>
        <Button type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </div>
  )

  return (
    <CommonScreen
      withCriteria={withCriteria}
      withUnitSelection
      isAdminScreen
      title={title}
      header={headerWithFormatter}
      saveTask={savePJMUnitTransfer}
      retrieveTask={getPJMUnitTransfer}
      deleteTask={deletePJMUnitTransfer}
      altBy={d => d.unitId}
      autoRetrieve={false}
      sortOptions={PJMUnitTransferHeaders}
      widthOffset={100}
      heightOffset={270}
      insertComp={insertEvent && insertComp}
      onInsertEvent={b => setInsertEvent(b)}
      insertCompHeight={0}
      autoFixColByKey={false}
      headerRowHeight={60}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
})

export default connect(mapStateToProps)(PJMUnitTransfer)

export const PJMUnitTransferHeaders = [
  utilityHeader,
  unitIdHeader,
  dateCol({
    ident: 'effectiveDate',
    display: 'Effective Date',
    isKey: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'threshold',
    display: 'Threshold',
    sortOrder: 'asc',
  }),
  { ...utilityHeader, ident: 'upperUtility', display: 'Upper Utility' },
  { ...unitIdHeader, ident: 'upperUnitId', display: 'Upper Unit' },
  { ...utilityHeader, ident: 'lowerUtility', display: 'Lower Utility' },
  { ...unitIdHeader, ident: 'lowerUnitId', display: 'Lower Unit' },
]
